import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AngularFireAuthGuard } from '@angular/fire/auth-guard';

const routes: Routes = [
	{
		path: '',
		loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
	},
	{
		path: 'forms',
		loadChildren: () => import('./forms/forms.module')
			.then(m => m.FormsModule), canActivate: [AngularFireAuthGuard]
	},
	// {
	// 	path: 'forms/animal-interaction',
	// 	loadChildren: () => import('./forms/animal-interaction/animal-interaction.module')
	// 		.then(m => m.AnimalInteractionModule), canActivate: [AngularFireAuthGuard]
	// }, {
	// 	path: 'forms/ncbi-download',
	// 	loadChildren: () => import('./forms/ncbi-download/ncbi-download.module')
	// 		.then(m => m.NcbiDownloadModule), canActivate: [AngularFireAuthGuard]
	// }
];



@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule { }
